import type { ParentComponent } from 'solid-js';
import { APP_VERSION } from '~/shared/lib/app-info';

export const AuthLayout: ParentComponent = (props) => {
  return (
    <div class="grain min-h-screen relative overflow-hidden bg-[hsl(222_15%_5%)]">
      <CourtBackdrop />

      <div class="relative z-10 min-h-screen grid grid-cols-1 lg:grid-cols-[58fr_42fr]">
        <IdentityPanel />
        <div class="flex items-center justify-center px-6 py-10 lg:px-12 lg:py-16">
          <div class="w-full max-w-[440px]">{props.children}</div>
        </div>
      </div>
    </div>
  );
};

const CourtBackdrop = () => (
  <div class="pointer-events-none absolute inset-0" aria-hidden="true">
    <div
      class="absolute inset-0 opacity-[0.07]"
      style={{
        'background-image': `
          linear-gradient(90deg, hsl(0 0% 100% / 0.45) 1px, transparent 1px),
          linear-gradient(0deg, hsl(0 0% 100% / 0.45) 1px, transparent 1px)
        `,
        'background-size': '92px 92px, 92px 92px',
        transform: 'rotate(-14deg) scale(1.4)',
        'transform-origin': 'center',
      }}
    />
    <div
      class="absolute -bottom-[280px] -left-[200px] w-[900px] h-[900px] rounded-full opacity-55 blur-[140px]"
      style={{
        background:
          'radial-gradient(circle at 50% 50%, hsl(92 87% 44% / 0.55) 0%, hsl(92 87% 44% / 0.10) 45%, transparent 70%)',
      }}
    />
    <div
      class="absolute -top-[200px] -right-[200px] w-[700px] h-[700px] rounded-full opacity-30 blur-[130px]"
      style={{
        background:
          'radial-gradient(circle at 50% 50%, hsl(196 80% 55% / 0.35) 0%, transparent 70%)',
      }}
    />
    <div
      class="absolute inset-0"
      style={{
        background:
          'radial-gradient(ellipse at 70% 50%, transparent 0%, transparent 40%, hsl(222 15% 5% / 0.55) 100%)',
      }}
    />
  </div>
);

const IdentityPanel = () => (
  <aside
    class="relative px-8 py-10 lg:px-16 lg:py-16 flex flex-col justify-between min-h-[260px] lg:min-h-screen"
    style={{
      'font-family': "'Bricolage Grotesque', 'SF Pro Display', system-ui, sans-serif",
    }}
  >
    <header class="auth-reveal" style={{ '--auth-reveal-delay': '0ms' }}>
      <div class="inline-flex items-center gap-2 px-2.5 py-1 rounded-full text-[11px] uppercase tracking-[0.22em] text-[hsl(92_60%_72%)]"
           style={{
             background: 'hsl(92 87% 44% / 0.08)',
             'box-shadow': 'inset 0 0 0 1px hsl(92 87% 44% / 0.20)',
           }}>
        <span class="relative inline-flex h-1.5 w-1.5">
          <span class="absolute inset-0 rounded-full bg-[hsl(92_87%_55%)] opacity-75 animate-ping" />
          <span class="relative rounded-full h-1.5 w-1.5 bg-[hsl(92_87%_55%)]" />
        </span>
        SportPark · v{APP_VERSION}
      </div>
    </header>

    <div class="relative">
      <h1
        class="auth-reveal text-[clamp(64px,11vw,168px)] leading-[0.85] tracking-[-0.04em] font-bold text-white"
        style={{ '--auth-reveal-delay': '120ms' }}
      >
        SPORT<wbr />
        <span class="inline-block relative">
          <span
            style={{
              background: 'linear-gradient(180deg, hsl(0 0% 100%) 0%, hsl(92 87% 60%) 100%)',
              '-webkit-background-clip': 'text',
              'background-clip': 'text',
              color: 'transparent',
            }}
          >
            PARK
          </span>
          <span
            class="auth-underline absolute -bottom-2 left-0 right-0 h-[3px] origin-left"
            style={{
              background: 'linear-gradient(90deg, hsl(92 87% 55%) 0%, transparent 100%)',
              '--auth-reveal-delay': '420ms',
            }}
          />
        </span>
      </h1>
      <p
        class="auth-reveal mt-7 text-[15px] lg:text-[17px] text-[hsl(0_0%_98%/0.62)] max-w-[480px] leading-relaxed"
        style={{
          '--auth-reveal-delay': '260ms',
          'font-family': "'SF Pro Text', 'Inter', system-ui, sans-serif",
        }}
      >
        Операционная система спортивного клуба.
        <br class="hidden lg:inline" />
        Расписание, оплаты, лояльность — в одной панели.
      </p>
    </div>

  </aside>
);
